// Libraries
import { QueryFunctionContext } from '@tanstack/react-query';
// Services
import { VoyagesResponseSchema, getVoyages } from '@services/apiGateway';
// Types
import { VesselControllerParams } from '@globalTypes/index';

/**
 * Controller function for fetching voyage data using the `getVoyages` service.
 *
 * @async
 * @function voyagesController
 * @typedef { imo: number } QueryFunctionContextParams
 * @typedef {[_: any, params: QueryFunctionContextParams]} QueryFunctionContext
 * @param {QueryFunctionContext} queryKey - The context object containing the query key.
 * @param {Array} queryKey
 * @param {number} params.imo - The IMO number of the vessel.
 * @returns {Promise<Voyages | undefined>} A promise that resolves with the parsed `Voyages` object or `undefined` if there was an error.
 */
export const voyagesController = async ({ queryKey }: QueryFunctionContext) => {
  const [_, params] = queryKey;
  const { imo } = params as VesselControllerParams;
  const { data } = await getVoyages(imo);

  return VoyagesResponseSchema.parse(data).data;
};
